import i18n from 'i18next';
// import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { reactI18nextModule } from 'react-i18next';

import { changeLanguage } from 'actions/i18n';

import { getLanguageLocalStorage } from './storage';
import resources from './resources';

const MAPPING_LANGUAGE = {
	'zh-tw': 'zh-TW',
	en: 'en',
};

export const LANGUAGE_OPTIONS = [
	{
		label: '中文',
		value: 'zh-TW',
	},
	{
		label: 'English',
		value: 'en',
	},
];

export const mapLanguageName = lan => {
	const [name = '中文'] = LANGUAGE_OPTIONS.filter(item => item.value === lan).map(
		item => item.label,
	);

	return name;
};

export const isLanguageSupportWithRoute = route => Object.keys(MAPPING_LANGUAGE).includes(route);

export const routeMapLanguage = route => {
	const [lang = 'zh-TW'] = Object.keys(MAPPING_LANGUAGE)
		.filter(key => key === route)
		.map(key => MAPPING_LANGUAGE[key]);

	return lang;
};

export const languageMapRoute = lan => {
	const [route = 'zh-tw'] = Object.keys(MAPPING_LANGUAGE).filter(
		key => MAPPING_LANGUAGE[key] === lan,
	);

	return route;
};

const languageDetect = {
	name: 'urlDetect',

	lookup() {
		const pathnames = window.location.pathname.split('/');

		if (pathnames.length >= 2) {
			return routeMapLanguage(pathnames[1]);
		}

		return 'zh-TW';
	},
};

export const initi18next = store => {
	const lngDetector = new LanguageDetector();
	// Setup Custom detector;
	lngDetector.addDetector(languageDetect);

	i18n
		// .use(Backend)
		.use(lngDetector)
		.use(reactI18nextModule)
		.init(
			{
				fallbackLng: 'zh-TW',

				// have a common namespace used around the full app
				ns: ['common'],
				defaultNS: 'common',

				debug: process.env.NODE_ENV !== 'production',

				interpolation: {
					escapeValue: false, // not needed for react!!
				},

				// Open when use backend
				// saveMissing: true,

				react: {
					wait: true,
				},

				detection: {
					order: ['urlDetect', 'localStorage', 'cookie', 'navigator', 'htmlTag'],
					lookupLocalStorage: getLanguageLocalStorage(),
				},

				caches: ['localStorage'],

				// Fakes translations resources. If you want to use backend, turn off this.
				resources,
			},
			() => {
				store.dispatch(changeLanguage(i18n.language));
			},
		);

	i18n.on('languageChanged', () => {
		store.dispatch(changeLanguage(i18n.language));
	});

	return i18n;
};

export const changeLng = lng => i18n.changeLanguage(lng);

export const getLanguage = () => i18n.language;

export const t = (keys, options) => i18n.t(keys, options);



// WEBPACK FOOTER //
// ./src/util/i18n.js